import { memo } from "react";
import ImportComponent from "./ImportComponent";
import { IJsonArr, downloadCSV } from "src/utils/utils";
import {
  InternalPaymentMethodInput,
  PaymentMethodJsonArrInput,
  useMigratePaymentMethodsMutation,
  usePaymentMethodSampleCsvLazyQuery,
} from "src/generated/graphql";
import { MESSAGES } from "src/utils/constants";
import { errorNotification } from "src/utils/alerts";
import { migrateErrors } from "./migrateMessage";

type IPaymentMethodImports = {
  locId: string;
};

function PaymentMethodImports({ locId }: IPaymentMethodImports) {
  const [getSampleCsv, { loading: isCsvDownloading }] =
    usePaymentMethodSampleCsvLazyQuery();

  const [migrateRecords, { loading: uploadloading }] =
    useMigratePaymentMethodsMutation();

  const onUpload = async (jsonArr: IJsonArr) => {
    try {
      const notesJsonArrInput: PaymentMethodJsonArrInput = {
        data: jsonArr as InternalPaymentMethodInput[],
      };
      const { data } = await migrateRecords({
        variables: { data: notesJsonArrInput, locationId: locId },
      });
      data && migrateErrors(data.migratePaymentMethods.errors);
    } catch (err) {
      errorNotification({ message: MESSAGES.INVALID_CSV });
    }
  };

  const onDownload = async () => {
    const { data } = await getSampleCsv();
    downloadCSV(data?.paymentMethodSampleCSV, "Payment_Method_Sample.csv");
  };
  return (
    <>
      <ImportComponent
        title="Step 4 - Payment Methods Import"
        onDownload={onDownload}
        onUpload={onUpload}
        loading={isCsvDownloading}
        uploadloading={uploadloading}
        bannerContent={
          "This feature requires the payment processor to have already migrated token data."
        }
      />
    </>
  );
}

export default memo(PaymentMethodImports);
